const NOMINATIM_SEARCH_URL = "https://nominatim.openstreetmap.org/search";

function normalizeLimit(limit) {
  const parsedLimit = Number(limit);
  return Number.isFinite(parsedLimit) && parsedLimit > 0
    ? Math.min(Math.round(parsedLimit), 20)
    : 6;
}

function normalizeLocationResult(item, index) {
  const lat = Number(item?.lat);
  const lng = Number(item?.lon);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  const label = String(item?.display_name || "").trim();

  return {
    id: String(item?.place_id || `${lat}:${lng}:${index}`),
    label: label || `${lat.toFixed(5)}, ${lng.toFixed(5)}`,
    lat,
    lng,
    raw: item,
  };
}

export async function searchMapLocations(query, { signal, limit = 6 } = {}) {
  const trimmedQuery = String(query || "").trim();

  if (trimmedQuery.length < 3) {
    return [];
  }

  const params = new URLSearchParams({
    format: "json",
    q: trimmedQuery,
    "accept-language": "en",
    limit: String(normalizeLimit(limit)),
  });

  const response = await fetch(`${NOMINATIM_SEARCH_URL}?${params.toString()}`, {
    signal,
  });

  if (!response.ok) {
    throw new Error("Map location search failed");
  }

  const payload = await response.json();
  if (!Array.isArray(payload)) {
    return [];
  }

  return payload
    .map((item, index) => normalizeLocationResult(item, index))
    .filter(Boolean);
}
